// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"e7e68810","36":"6bd675fc","272":"ca4c0684","787":"a4b45000","925":"05f34f86"}[chunkId] + ".chunk.js";
};